import { render, staticRenderFns } from "./dfsquiz.vue?vue&type=template&id=66e16813&"
import script from "./dfsquiz.vue?vue&type=script&lang=js&"
export * from "./dfsquiz.vue?vue&type=script&lang=js&"
import style0 from "./dfsquiz.vue?vue&type=style&index=0&id=66e16813&prod&lang=css&"
import style1 from "./dfsquiz.vue?vue&type=style&index=1&id=66e16813&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports